import React, { useState } from 'react';
import { HomefieldIconChevronDown, HomefieldIconChevronUp } from '@dsg-tech/homefield-react-icons';
import { CsvData } from 'types';
import { replaceSpaceAndCapitalize, searchifyTerm } from 'utility/utility';
import './MobileAccordion.scss';
import { TextLink } from '@dsg-tech/homefield-react';

interface AccordionProps {
  title: string;
  children: React.ReactNode;
}

const AccordionItem = ({ title, children }: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="accordion-item">
      <button
        aria-expanded={isOpen}
        type="button"
        className="accordion-header hmf-display-flex hmf-align-items-center hmf-justify-content-center hmf-p-0"
        onClick={toggleAccordion}>
        <h3 className="hmf-m-0 hmf-text-transform-uppercase hmf-body-bold-l">{title}</h3>
        <span>
          {isOpen ? (
            <HomefieldIconChevronUp width="24px" height="24px" />
          ) : (
            <HomefieldIconChevronDown width="24px" height="24px" />
          )}
        </span>
      </button>
      <section
        aria-label="accordion-content"
        className={`accordion-content hmf-display-flex hmf-flex-col hmf-align-items-center${
          isOpen ? ' open' : ''
        }`}>
        {children}
      </section>
    </div>
  );
};

interface MobileAccordionProps {
  links: CsvData[];
}

const MobileAccordion = ({ links }: MobileAccordionProps) => {
  return (
    <div data-testid="MobileAccordion" className="footer-mobile-accordion hmf-display-lg-none">
      {links.map((link) => (
        <AccordionItem title={link.n} key={link.n}>
          {link.col[0]?.cats.map((cat) => (
            <div key={`${cat.n}-${cat.u}`}>
              <TextLink
                variant="group"
                size="small"
                className="hmf-py-xs"
                href={cat.u}
                data-em={`Footer_${replaceSpaceAndCapitalize(searchifyTerm(cat.n))}`}>
                {cat.n}
              </TextLink>
            </div>
          ))}
        </AccordionItem>
      ))}
    </div>
  );
};

export default MobileAccordion;
